<template>
    <section>
        <div class="page-wrap">
            <div class="container product">
                <div class="box-content">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="prod-container">
                                <img class="prod-img" v-bind:src="'images/catalog/' + campaign.short_url + '/' + product.item_image_blank"/>
                                <div class="prod-replica">
                                    <div class="prod-replica-table">
                                        <div class="prod-replica-table-td">
                                            <p v-for="n in product.max_lines">{{ lines[n-1] }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <h3 v-html="product.description"></h3>
                            <h4>$&nbsp;{{ product.price }}</h4>
                            <hr/>
                            <h3>
                                <a class="text-danger underline pointer"
                                   v-on:click="showInscriptionGuidelines()"
                                >Inscription Guidelines</a>*
                            </h3>
                            <div class="brick-text-form">
                                <div v-for="n in product.max_lines" class="form-group row no-gutter">
                                    <div class="col-md-2">
                                        <label v-bind:for="'l-' + n">Line {{ n }}:</label>
                                    </div>
                                    <div class="col-md-10">
                                        <greek-letters-dropdown v-bind:line-id="'l-' + n">
                                            <input class="form-control"
                                                v-on:keydown="withAnyKeyDown($event)"
                                                v-on:keyup="withAnyKeyUp($event)"
                                                v-on:input="withInput($event)"
                                                v-bind:id="'l-' + n"
                                                v-bind:value="lines[n-1]"
                                                v-bind:maxlength="product.max_characters"
                                                v-bind:size="product.max_characters"
                                            />
                                        </greek-letters-dropdown>
                                    </div>
                                </div>
                            </div>
                            <p>Need inspiration?
                                <a class="text-danger pointer" v-on:click="showInscriptionExamples()">Click here</a>
                                for inscription examples.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>
                                <span class="text-danger">*</span>
                                Indian Creek Plaza reserves the right to approve all brick inscriptions.
                                Inscriptions that do not conform to these inscription guidelines or that are deemed
                                unsuitable will be declined and will require a new inscription to be submitted.
                            </p>
                        </div>
                    </div>
                    <preferred-location v-if="isLocationPreferenceAllowed"
                        v-bind:options="product.options || {}"
                        v-bind:location="location"
                        on-location-change="onCartItemLocationChange"
                    ></preferred-location>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="btn-wrap text-right">
                                <a class="btn btn-danger btn-md" v-on:click="saveInscription">Save</a>
                                <a class="btn btn-danger btn-md" v-on:click="cancelEditing">Cancel</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script type="text/jsx">
    import Vue from 'vue'
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import store from '../../store'
    import { mapState, mapGetters } from 'vuex'
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import InscriptionEditMixin from '../../../../../assets/js/components/frontend/mixin/inscription-edit.vue'
    import InscriptionHandlingMixin from '../mixin/inscription-handling.vue'
    import GreekLettersDropdown from '../elements/greek-letters-dropdown.vue'
    import PreferredLocation from '../elements/preferred-location.vue'
    export default {
        name: 'edit-inscription',
        mixins: [
            CampaignConfigurationMixin,
            InscriptionEditMixin,
            InscriptionHandlingMixin
        ],
        components: {
            'greek-letters-dropdown': GreekLettersDropdown,
            'preferred-location': PreferredLocation
        },
        props: {
            isLowerCaseAllowed: { // to override default value in InscriptionEditMixin
                type: String,
                default: () => 'no'
            }
        },
        beforeRouteEnter (to, from, next) {
            let cartId = to.params.id;
            if (cartId in store.getters.cart) {
                let item = store.getters.cart[cartId];
                let isGc = 'gc' in item ? item.gc : false;
                if (isGc) {
                    next({name: 'Cart'})
                } else {
                    next();
                }
            } else {
                next({name: 'Cart'});
            }
        },
        computed: {
            ...mapState([
                'campaign'
            ]),
            ...mapGetters([
                'products', 'cart'
            ]),
            product: function () {
                var cartId = this.$route.params.id;
                var itemId = this.cart[cartId].item_id;
                if (itemId in this.products) {
                    return this.products[itemId];
                }
                return {};
            },
            lines: function () {
                return this.cart[this.$route.params.id].lines;
            },
            location: {
                get: function () {
                    var location = '';
                    var options = this.cart[this.$route.params.id].options || {};
                    if ('location' in options) {
                        location = options.location;
                    }
                    return location;
                },
                set: function (newValue) {
                    // it is not allowed to be modified directly
                    console.log('attempt to set location to new value:', newValue);
                }
            }
        },
        created: function () {
            Event.$on('onCartItemLocationChange', this.onLocationChange);
        },
        beforeDestroy: function () {
            Event.$off('onCartItemLocationChange', this.onLocationChange);
        },
        methods: {
            showInscriptionGuidelines: function () {
                Event.$emit('inscriptionGuidelinesPopup');
            },
            showInscriptionExamples: function () {
                Event.$emit('inscriptionExamplesPopup');
            },
            updateInscription: function (data) {
                if ('id' in data && 'text' in data) {
                    var parts = ('' + data.id).split('-', 2); // eq. l-1
                    if (parts.length == 2) {
                        var lineIndex = +parts[1] - 1;
                        Vue.set(this.lines, lineIndex, data.text);
                    }
                }
            },
            onLocationChange: function (newLocation) {
                this.$store.commit('updatePreferredLocation', {
                    cartId: +this.$route.params.id,
                    location: newLocation
                });
            },
            saveInscription: function () {
                this.$store.commit('updateInscription', {
                    cartId: +this.$route.params.id,
                    lines: this.lines
                });
                this.$router.push({ path: '/cart'});
            },
            cancelEditing: function () {
                this.$router.push({ path: '/cart'});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// EditInscription.vue?4f24899a